
import { defineComponent, ref, watch } from 'vue';
import VChart from 'vue-echarts';

import { GaugeChart } from 'echarts/charts';
import {
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent,
} from 'echarts/components';
import { use } from 'echarts/core';
import { CanvasRenderer, SVGRenderer } from 'echarts/renderers';

import Overlay from '@/components/Overlay.vue';

use([
  GaugeChart,
  CanvasRenderer,
  SVGRenderer,
  GridComponent,
  TooltipComponent,
  TitleComponent,
  LegendComponent,
]);
export default defineComponent({
  name: 'DashboardDailyBilling',

  components: {
    VChart,
    Overlay,
  },

  props: {
    averagePeriod: {
      type: Number,
      default: 0,
    },

    billedDay: {
      type: Number,
      default: 0,
    },

    chartValue: {
      type: [Number, String],
      default: 0,
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const propsRef = ref(props);
    const chart = ref();
    watch(propsRef.value, () => {
      chart.value.setOption({
        series: [
          {
            type: 'gauge',
            splitNumber: 10,
            startAngle: 215,
            endAngle: -35,
            center: ['50%', '48%'],
            max: 50,
            axisLine: {
              lineStyle: {
                width: 20,
                color: [
                  [0.14, '#CB3645'],
                  [0.3, '#FF6A13'],
                  [0.5, '#FFC700'],
                  [0.7, '#C1E54E'],
                  [1, '#00AFD7'],
                ],
              },
            },
            pointer: {
              itemStyle: {
                color: '#e4332f',
              },
              width: 5,
              length: '70%',
              offsetCenter: [0, '8%'],
            },
            axisTick: {
              distance: -20,
              length: 5,
              lineStyle: {
                color: '#fff',
                width: 2,
              },
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              distance: -36,
              color: '#666',
              fontSize: 12,
            },
            anchor: {
              size: 1,
              itemStyle: {
                borderWidth: 10,
              },
            },
            title: {
              show: false,
            },
            detail: {
              valueAnimation: true,
              fontSize: 80,
              formatter: () => {
                return `{segment| } \n {segment2|Faturado Dia: ${propsRef.value.billedDay}} \n {segment3| Média periodo: ${propsRef.value.averagePeriod}}`;
              },
              offsetCenter: [0, '90%'],
              rich: {
                value: {
                  lineHeight: 14,
                  verticalAlign: 'top',
                  align: 'center',
                  padding: [-28, 0, 0, 0],
                },
                segment: {
                  height: 20,
                  align: 'center',
                  verticalAlign: 'bottom',
                  color: '#666',
                  fontSize: 12,
                  padding: [-58, 0, 0, 20],
                },
                segment3: {
                  height: 50,
                  align: 'center',
                  verticalAlign: 'bottom',
                  color: '#666',
                  fontSize: 12,
                  padding: [0, 0, 0, -28],
                },
                segment2: {
                  height: 20,
                  align: 'center',
                  verticalAlign: 'bottom',
                  lineHeight: -100,
                  color: '#666',
                  fontSize: 12,
                  padding: [0, 0, 0, 0],
                },
              },
            },
            data: [
              {
                value: propsRef.value.chartValue,
              },
            ],
          },
        ],
      });
    });
    const options = ref({
      series: [
        {
          type: 'gauge',
          splitNumber: 10,
          startAngle: 215,
          endAngle: -35,
          center: ['50%', '48%'],
          max: 50,
          axisLine: {
            lineStyle: {
              width: 20,
              color: [
                [0.14, '#CB3645'],
                [0.3, '#FF6A13'],
                [0.5, '#FFC700'],
                [0.7, '#C1E54E'],
                [1, '#00AFD7'],
              ],
            },
          },
          pointer: {
            itemStyle: {
              color: '#e4332f',
            },
            width: 5,
            length: '70%',
            offsetCenter: [0, '8%'],
          },
          axisTick: {
            distance: -20,
            length: 5,
            lineStyle: {
              color: '#fff',
              width: 2,
            },
          },
          splitLine: {
            show: false,
          },
          axisLabel: {
            distance: -36,
            color: '#666',
            fontSize: 12,
          },
          anchor: {
            size: 1,
            itemStyle: {
              borderWidth: 10,
            },
          },
          title: {
            show: false,
          },
          detail: {
            valueAnimation: true,
            fontSize: 80,
            formatter: () => {
              return `{segment| } \n {segment2|Faturado Dia: ${propsRef.value.billedDay}} \n {segment3| Média periodo: ${propsRef.value.averagePeriod}}`;
            },
            offsetCenter: [0, '90%'],
            rich: {
              value: {
                lineHeight: 14,
                verticalAlign: 'top',
                align: 'center',
                padding: [-28, 0, 0, 0],
              },
              segment: {
                height: 20,
                align: 'center',
                verticalAlign: 'bottom',
                color: '#666',
                fontSize: 12,
                padding: [-58, 0, 0, 20],
              },
              segment3: {
                height: 50,
                align: 'center',
                verticalAlign: 'bottom',
                color: '#666',
                fontSize: 12,
                padding: [0, 0, 0, -28],
              },
              segment2: {
                height: 20,
                align: 'center',
                verticalAlign: 'bottom',
                lineHeight: -100,
                color: '#666',
                fontSize: 12,
                padding: [0, 0, 0, 0],
              },
            },
          },
          data: [
            {
              value: propsRef.value.chartValue,
            },
          ],
        },
      ],
    });

    return { options, propsRef, chart };
  },
});
